module.exports = "//s1.igetcool.com/mall-h5/img/h5_bg_top_success@2x.dbc74328.png";